/**
 * The payouts module's routes, owned by the feature (D5). `src/app/router.tsx` spreads this array,
 * and it did not have to change when T71 closed F-069 and that file replaced `src/App.tsx` as the
 * composer — which is the point of exporting an array rather than a `<Route>` tree.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const PayoutsPage = lazy(() => import('./PayoutsPage'));

export const payoutsRoutes: RouteObject[] = [{ path: 'payouts', element: <PayoutsPage /> }];
